import React from 'react'
import Image from 'next/image'

const IndustriesServed = ({ currentSection }) => {
    const industriesLIst = [
        {
            heading: 'Biometrics and Identity',
            image: '/industries/passport.png',
            featureList: [
                {
                    text: 'Chip with inlays for ID1 and ID3',
                },
                { text: 'RFID chips with antenna' },
                {
                    text: 'High security lamination plates for ID cards and passport',
                },
                {
                    text: 'Complete personalization solutions for ID cards and passport',
                },
                {
                    text: 'Holograms, ROVID/DOVID and other customized security features',
                },
            ],
        },
        {
            heading: 'Security Printing',
            image: '/industries/secure-printing.png',
            featureList: [
                {
                    text: 'Security Papers for Cheques',
                },
                { text: 'Degrees and Certificates' },
                {
                    text: 'Passport Papers',
                },
                {
                    text: 'Ballot Papers',
                },
                {
                    text: 'Security Inks',
                },
                {
                    text: 'Security MICR Toners for Personalization and Data Printing',
                },
                {
                    text: 'Complete Production System',
                },
            ],
        },
        {
            heading: 'Paper Products',
            image: '/industries/paper-product.jpg',
            featureList: [
                {
                    text: 'Offset Paper in Reels and Sheets',
                },
                {
                    text: 'A4 Paper in 70/75/80 gsm',
                },
                {
                    text: 'Thermal Paper',
                },
                {
                    text: 'Coated and Metallized Papers',
                },
                {
                    text: 'Paperboard for Luxury Printing',
                },
                {
                    text: 'Anti-counterfeit Paper',
                },
            ],
        },
        {
            heading: 'Banking and Financial',
            image: '/industries/ncnic.png',
            featureList: [
                {
                    text: 'ATM, Debit and Credit Cards',
                },
                {
                    text: 'MICR Printers',
                },
                {
                    text: 'A4 Paper',
                },
            ],
        },
        {
            heading: 'Packaging',
            image: '/industries/packaging.jpg',
            featureList: [
                {
                    text: 'Sheetfed Inks',
                },
                {
                    text: 'Coatings',
                },
                {
                    text: 'UV Inks',
                },
            ],
        },
    ]

    return (
        <section
            className={` secondary-section section  ${currentSection}`}
            id="section-industrial-served"
        >
            <div className="container mx-auto overflow-visible">
                <div className={``}>
                    <div className="animate__animated animate__fadeInDown mb-12 text-center opacity-0">
                        <h2 className="">Industries Served</h2>
                        <p className="mx-auto max-w-[720px] text-interface-700  ">
                            At Amanco, we cater to a diverse range of
                            industries, including security printing and
                            identity, paper products, banking, and packaging.
                        </p>
                    </div>
                    <div>
                        <ul className="industries-list">
                            {industriesLIst.map((item, index) => (
                                <li
                                    className={` item animate__animated animate__fadeInDown opacity-0 `}
                                    key={index}
                                >
                                    <div className="content w-2/4 mobile:w-full">
                                        <div>
                                            <h3 className="text-[#18191F]">
                                                {item.heading}
                                            </h3>
                                            <ul className="features">
                                                {item.featureList.map(
                                                    (list, indexChild) => (
                                                        <li key={indexChild}>
                                                            {list.text}
                                                        </li>
                                                    )
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="w-2/4 mobile:w-full">
                                        <div className="image">
                                            <Image
                                                src={item.image}
                                                alt={item.heading}
                                                width={523}
                                                height={304}
                                            />
                                        </div>
                                    </div>
                                </li>
                            ))}
                            <li></li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default IndustriesServed
